<script>
import { mapState, mapMutations } from "vuex";
import InfoTooltip from "@/components/InfoTooltip";
import { sleep } from "@/utils";

export default {
  // Included components
  components: {
    InfoTooltip,
  },

  props: {
    // The text to display in the tooltip
    text: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      // Whether auto refresh is enabled
      value: false,

      // Whether currently running timers
      running: false,
    };
  },

  computed: {
    ...mapState(["autoRefreshEnabled"]),
  },

  created() {
    // Set the auto refresh toggle
    this.value = this.autoRefreshEnabled;
  },

  watch: {
    // When the value changes, save the new value to local storage.
    // If the new value is true, then start up the timers
    value() {
      this.setAutoRefreshEnabled(this.value);
      if (this.value) {
        this.startTimers();
      }
    },
  },

  methods: {
    // Run the auto refresh timers
    async startTimers() {
      // Prevent timers from doubling up
      if (this.running) return;
      this.running = true;

      while (this.value) {
        // Calculate when the next 30-second aligned time is
        let now = new Date().getTime();
        let next30 = Math.floor(now / 30000) * 30000 + 30000;

        // Sleep until then (nonblocking) with 5 second delay to
        // allow for alerts to compute
        await sleep(next30 - now + 5000);

        // Cancel if no longer autorefreshing
        if (!this.value) return;

        // Emit an update for 30 seconds
        this.$emit("update-30s", next30);

        // If minute-aligned, emit update for 60 seconds
        if (next30 % 60000 == 0) {
          this.$emit("update-1m", next30);
        }

        // If 5-minute-aligned, emit update for 5 minutes
        if (next30 % 300000 == 0) {
          this.$emit("update-5m", next30);
        }
      }

      // Allow future calls to proceed
      this.running = false;
    },

    // Mapped vuex actions
    ...mapMutations(["setAutoRefreshEnabled"]),
  },
};
</script>

<template>
  <b-form-checkbox v-model="value" class="d-inline-block">
    {{ text || "Auto Refresh" }}
    <InfoTooltip text="Refresh new data as it becomes available." />
  </b-form-checkbox>
</template>

<style></style>
